export const DiscountsModelModule = angular
    .module('app.services.model.models.discounts', [])
    .value('discountModel', {
        code: 'String',
        createdOn: 'String',
        criteria: {
            couponCode: 'String',
            maximumPurchaseQuantity: 'Number',
            minimumPurchaseQuantity: 'Number',
            requiresCouponCode: ['Boolean', true]
        },
        currentUsageCount: ['Number', 0],
        customerUsageLimit: 'Number',
        discountType: 'String',
        endDateTime: 'String',
        fixedPriceReduction: 'Number',
        hasEndDateTime: 'Boolean',
        hasStartDateTime: 'Boolean',
        id: 'String',
        isActive: ['Boolean', true],
        isHidden: 'Boolean',
        isLimitedPerCustomer: 'Boolean',
        percentagePriceReduction: 'Number',
        revision: 'Number',
        scope: {
            entireStore: 'Boolean',
            items: 'Array'
        },
        startDateTime: 'String',
        tenant: 'String',
        totalUsageCount: ['Number', 0],
        unlimited: 'Boolean',
        unlimitedDuration: 'Boolean',
        updatedOn: 'String',
        usageLimit: 'Number'
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/model/models/discounts.model.js